import React from 'react';
import ComponentContainer from './atoms/ComponentContainer';
import type { Masthead as MastheadProps } from '../types/app';
import MastHeadComponent from './atoms/MastHead';

export const MastHead = (props: MastheadProps) => (
    <ComponentContainer contentful_id={props.contentful_id} fullWidth={true} sx={{p:0}}>
        <MastHeadComponent {...(props as MastheadProps)} />
    </ComponentContainer>
);

export default MastHead;
